var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Sidebar',{ref:"sidebar"}),_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('div',{staticClass:"content-box",class:[_vm.tt, { 'content-mobile': _vm.isMobile }]},[_c('Right')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }